// the PopupForm class activates an element to draw a popup window on top
// Designed for a form, but I guess it could be used with just regular html, as long as you have a cancel button

// Store the URL in the rel tag or the href tag

// Built to works with AjaxForm but not required.  Expects AjaxForm to be attached with the content_processor.

// Some noteable events that are fired: 
/*
 resize_popup_event_name: 'resize_popup', // Name of the event that fires to resize the popup
 close_popup_event_name: 'close_popup', // Name of the event to close the popup
 open_popup_event_name: 'open_popup', // Name of the event to open the popup
 popup_closed_event_name: 'popup_closed', // Name of the event that is fired after the popup is successfully closed
 popup_opened_event_name: 'popup_opened' // Name of the event that is fired after the popup is successfully opened. 
 */

var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.BasicPopup = new Class({
    Implements: [Options, Events],
    mask: {},
    close_popup_function: jQuery.noop, // The function for the close event (so we can remove it)
    esc_test_bound: null, // the bound function for the keyup event
    popup_avialable: true, // Flag to prevent double-clicking from opening the form twice
    container: null, // The container
    popup_close_container: null,
    popup_content: null,
    options: {
        popup_mask_ops: {},
        use_mask: true,
        request_data_once: false,
        popup_container_class: 'popup_container', // The class for the container
        popup_content_class: 'popup_content', // The class for the content        
        popup_close_container_class: 'popup_close_container',
        popup_close_button_class: 'popup_close_button',
        popup_content_container_class: 'popup_content_container',
        popup_close_position: 'top',
        popup_data: '', // String data to be used for the popup if no url is provided
        popup_id: null, // ID to give the popup container so we can easily access it to close it.
        posting_data: null, // The posting data (query string) when getting the form
        cancel_selector: '.cancel', // The selector for any cancel buttons
        any_click_cancels: false, // Set to true to close the form on any click at the window level
        esc_closes: true, // Set to false to prevent the escape key from closing the popup
        close_anchor: '.close_anchor', // Apply this to an anchor to close the form but don't stop the event (i.e. a target _blank)
        event_type: 'click', // The event type to listen for.  Can be click, dblclick, keyup, etc.
        url: null, // If null, will use the rel tag or href tag
        openOnEvent: false, // Set to the event you wish to listen to on the container to open the popup. 
        draw_method: jQuery.noop,
        draw_base: true,
        target: null,
        js_resize: true, // Set to false ot disable all js resizing
        size_parameters: {
            'padding_height': 10,
            'scale_factor': 0.9,
            'content_padding': 20
        }, //How the popup should be sized.
        popup_container_styles: {
            'opacity': '1',
            'z-index': '10000',
            'position': 'fixed',
            'width': '100%',
            'height': '100%'
        },
        popup_box_styles: {
            'margin': 'auto',
            'margin-top': '30px',
            'width': '90%',
            'background': 'white',
            'opacity': '1',
            'border': '2px solid #000',
            'border-radius': '15px',
            'padding': '14px'
        },
        close_container_styles: {
        },
        close_button_styles: {
        },
        popup_content_styles: {
            'overflow-y': 'scroll'
        },

        popup_data_name: 'popup_form', // This is the data field that the popup instance will be stored under
        jquery_event_namespace: '.basic_popup', // The name space the event will be registered under.
        dom_resize_event_name: 'resize_event', // The name of the event that triggers the resizing of the popup
        resize_popup_event_name: 'resize_popup', // Name of the event that fires to resize the popup
        close_popup_event_name: 'close_popup', // Name of the event to close the popup
        open_popup_event_name: 'open_popup', // Name of the event to open the popup
        popup_closed_event_name: 'popup_closed', // Name of the event that is fired after the popup is successfully closed
        popup_opened_event_name: 'popup_opened', // Name of the event that is fired after the popup is successfully opened.
        popup_predraw_event_name: 'popup_pre_draw', // Name of the event that is fired before the draw method is fully executed.
        popup_postdraw_event_name: 'popup_post_draw' // Name of the event that is fired after the draw method is fully executed.
    },
    /*
     * Initialize:
     * 
     * Parameters: 
     *      Container: (A html object)
     *      op: An object containing options to overide and set. 
     * 
     */


    initialize: function (container, op) {
        var data_name;
        if (op.popup_data_name) {
            data_name = op.popup_data_name;
        } else {
            data_name = this.options.popup_data_name;
        }

        // Make sure we haven't processed this item yet
        var current_form = container.data(data_name);
        if (current_form) {
            if (op) {
                current_form.setOptions(op);
            }
            return current_form;
        } else {
            container.data(data_name, this);
        }
        this.setOptions(op);
        this.container = container;

        // Add a click event for the item
        //item.addEvent(this.options.event_type,this.open_form.bind(this));


        // Fire off the resize on the body where we will be listening with an open popup. 
        if (this.options.js_resize) {
            $(window).resize(this.on_resize.bind(this));
        }

        this.close_popup_function = function (e) {
            e.stop();
            this.close_form(e);
        }.bind(this);

        // If an open on event was specefied listen for it on the container. 
        if (this.options.openOnEvent) {
            this.container.on(this.options.openOnEvent + this.options.jquery_event_namespace, function (e) {
                this.open_popup(e);
            }.bind(this));
            this.addEvent(this.options.openOnEvent, this.open_popup.bind(this));
        }

        this.initialize_events();

    },
    initialize_events: function () {
        this.addEvent(this.options.close_popup_event_name, this.close_form.bind(this));
        this.addEvent(this.options.open_popup_event_name, this.open_popup.bind(this));
        this.addEvent(this.options.resize_popup_event_name, this.resize_popup.bind(this));
    },
    set_posting_data: function (data) {
        this.options.posting_data = data;
    },
    set_popup_data: function (data) {
        this.options.popup_data = data;
    },
    open_popup: function (event) {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        if (!this.popup_avialable) {
            return;
        }


        var target = this.get_target_container();

        // If we are using a mask instantiate it
        if (this.options.use_mask && OCS.Classes.Mask) {
            this.mask = new OCS.Classes.Mask(target, this.options.popup_mask_ops);
        }

        // The dom element that will hold the popup
        this.popup_container = jQuery("<div>", {
            "class": this.options.popup_container_class,
            "id": this.options.popup_id,
            "name": this.options.popup_id
        });

        // The dom element that will display the popup content
        this.popup_content = jQuery("<div>", {
            "class": this.options.popup_content_class,
        });
        this.popup_container.append(this.popup_content);

        // Attach the popup to the target container
        target.append(this.popup_container);




        var url = this.options.url;
        if (!url) {
            url = this.container.attr('rel');
        }
        // Adding functionality to check for the href tag
        if (!url) {
            url = this.container.attr('href');
        }

        this.container.data(this.options.popup_data_name, this);

        // Use the popup data option if provided and not a blank string or if there is no url provided
        if ((this.options.popup_data && this.options.popup_data !== '')) {
            this.process_result(this.options.popup_data);
        } else {
            if (url) {
                this.make_request(url);
            }
        }
        this.popup_opened_event();
    },
    make_request: function (url) {
        jQuery.ajax({
            'type': "GET",
            'url': url,
            'dataType': 'html',
            'data': this.options.posting_data,
            'success': this.process_result.bind(this),
            'update': this.popup_content,
            'context': this
        });
    },
    process_result: function (data) {
        // Is the js handling the base drawing of this popup?
        if (this.options.draw_base) {
            // Is by a method being provided to use or are we using the default drawing capabilities
            this.fireEvent(this.options.popup_predraw_event_name, this);
            if (this.draw_method) {
                this.draw_method();
            } else {
                this.base_draw();
            }
            this.fireEvent(this.options.popup_postdraw_event_name, this);
        }


        if (this.options.request_data_once) {
            // Prevent future request of the data by storing it
            this.set_popup_data(data);
        }

        //TODO: Handle data encapsulation
        this.popup_content.html(this.process_data(data));

        $(this.options.cancel_selector, $(this.popup_container)).each(function (item) {
            item.on('click' + this.options.jquery_event_namespace, this.close_form_function);
        }.bind(this));

        if (this.options.esc_closes) {
            this.esc_test_bound = this.esc_test.bind(this);
            $(document.body).on('keyup' + this.options.jquery_event_namespace, this.esc_test_bound.bind(this));
        }
        $(this.options.close_anchor, $(this.popup_container)).each(function (item) {
            // Don't use the close_formr_function here because we want the event to propogate
            item.on('click' + this.options.jquery_event_namespace, this.close_form.bind(this));
        }.bind(this));

        // After the form is processed display the mask with the popup on top
        if (this.options.use_mask) {
            this.mask.showMask();
        }

        if (this.options.js_resize) {
            this.register_resize_event();
        }



    },
    process_data: function (data) {
        // Process the data in preparation for being attached to the html
        return data;
    },
    register_resize_event: function () {
        $(document.body).on(this.options.dom_resize_event_name + this.options.jquery_event_namespace, this.resize_popup.bind(this));
        $(document.body).trigger(this.options.dom_resize_event_name);
    },
    unregister_resize_event: function () {
        $(document.body).off(this.options.dom_resize_event_name);
    },
    esc_test: function (e) {
        if (e.key == 'esc' || e.keyCode == 27) {
            this.close_form(e);
        }
    },
    close_form: function (json) {
        // Make sure we have a form
        if (!this.popup_container) {
            return;
        }

        this.popup_container.remove();
        this.popup_container = null;
        if (jQuery.type(json) != 'jQuery.Event') {
            this.fireEvent('success', this);
        }

        this.popup_avialable = true;

        if (this.esc_test_bound) {
            $(document.body).off('keyup', this.esc_test_bound);
        }
        if (this.options.use_mask) {
            this.mask.hideMask();
        }
        if (this.options.js_resize) {
            this.unregister_resize_event();
        }
        this.popup_closed_event();

    },
    base_draw: function () {
        // Popup stucture and naming convention

        //      -- popup container          -> The container the popup is drawn on top of
        //          -- popup box            -> the actual popup box, what the content will be drawn on
        //              -- popup content    -> the content of the popup will live here

        this.popup_container.css(this.options.popup_container_styles);
        //this.popup_container_content.css({});

        // The box now becomes what was the content
        this.popup_box = this.popup_content;

        this.popup_box.css(this.options.popup_box_styles);

        // Building out from here the elements contained within the popup box.

        // Build out the close container and its associated button but not going to attach it to the box just yet
        this.popup_close_container = jQuery("<div>", {
            "class": this.options.popup_close_container_class,
            "css": this.options.close_container_styles
        });
        this.popup_close_button = jQuery("<div>", {
            "class": this.options.popup_close_button_class,
            "css": this.options.close_button_styles
        });
        this.popup_close_button.on('click' + this.options.jquery_event_namespace, this.close_form.bind(this));
        this.popup_close_container.append(this.popup_close_button);



        // If close box is up top, attach it to the box now. 
        if (this.options.popup_close_position == 'top') {
            this.popup_box.append(this.popup_close_container);
        }

        // Now we build the div that will contain the actual content of the popup
        this.popup_content = jQuery("<div>", {
            "class": this.options.popup_content_container_class,
            "css": this.options.popup_content_styles
        });
        //this.popup_content.css({'overflow-y': 'scroll'});
        this.popup_box.append(this.popup_content);

        // Draw the close button on the bottom of the popup so its the last element attached.
        if (this.options.popup_close_position == 'bottom') {
            this.popup_box.append(this.popup_close_container);
        }
    },

    // Event Fires
    close_popup_event: function () {
        setTimeout(function () {
            this.fireEvent(this.options.close_popup_event_name, this);
        }.bind(this), 0);
    },
    open_popup_event: function () {
        setTimeout(function () {
            this.fireEvent(this.options.open_popup_event_name, this);
        }.bind(this), 0);
    },
    popup_closed_event: function () {
        setTimeout(function () {
            this.fireEvent(this.options.popup_closed_event_name, this);
        }.bind(this), 0);
    },
    popup_opened_event: function () {
        setTimeout(function () {
            this.fireEvent(this.options.popup_opened_event_name, this);
        }.bind(this), 0);
    },
    resize_event: function () {
        setTimeout(function () {
            this.fireEvent(this.options.resize_popup_event_name, this);
        }.bind(this), 0);
    },

    resize_popup: function (e) {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        }
        var target = this.get_target_container();
        var parent_height = target.height();
        var parent_width = target.width();


        var content_height = this.default_content_height_sizing(parent_height);
        var container_height = this.default_container_height_sizing(content_height);

        this.popup_container.height(parent_height);
        this.popup_container.width(parent_width);


        this.popup_container.height(container_height);
        this.popup_content.height(content_height);

    },
    default_content_height_sizing: function (parent_height) {
        return ((parent_height - this.options.size_parameters.padding_height) * this.options.size_parameters.scale_factor);
    },
    default_container_height_sizing: function (content_height) {
        return content_height + this.options.size_parameters.content_padding;
    },
    get_target_container: function () {
        var target;
        if (this.options.target) {
            target = this.options.target;
        } else {
            target = this.container;
        }
        return target;
    },
    on_resize: function () {
        try {
            $(document.body).trigger(this.options.resize_event_name);
        } catch (e) {
            console.warn("Unable to resize.", e);
        }
    },
    destroy: function () {
        this.container.data(this.options.popup_data_name, null);
        this.removeEvents();
    }

});

